import styled from 'styled-components';

import { media } from '../../../src/styles/media';

export const CustomForm = styled.form`
  max-width: 587px;
  margin: 0 auto;

  .Select-control {
    width: 100%;
    outline: none;
    font-size: 1.5rem;
    display: block;
    border: 1px solid #ccc;
    border-radius: 30px;
    margin-bottom: 30px;
    padding: 15px;
    height: 50px;
    padding: 15px 40px 15px 15px;
  }

  .Select-multi-value-wrapper {
    height: 100%;
    display: block;
  }

  .Select--single > .Select-control .Select-value {
    line-height: inherit;
    padding: 0px;
    position: relative;
    top: 3px;
    bottom: 0;
  }

  .Select-input {
    position: absolute;
    top: 0;
  }

  .Select-clear-zone {
    display: none;
  }

  .Select-menu-outer {
    position: absolute;
    top: 0;
    border: none;
    background-color: ${props => props.theme.color.white};
    letter-spacing: 2.5px;
    text-transform: uppercase;
    padding: 20px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    overflow: auto;
    max-height: 220px;
  }

  .Select-menu-outer > div {
    overflow: visible;
  }

  .menu-option-group-title {
    margin-bottom: 15px;
    font-size: 1.4rem;
    color: ${props => props.theme.color.black};
    font-family: ${props => props.theme.font.black};
  }

  .menu-option-item {
    padding-left: 25px;
    margin-bottom: 15px;
  }

  .menu-option {
    cursor: pointer;
    display: block;
    font-size: 1.4rem;
    margin-bottom: 10px;
    text-transform: none;
    color: ${props => props.theme.color.darkGrey};
  }

  .menu-option:hover {
    color: ${props => props.theme.color.primary};
  }

  .captcha > div > div > div {
    margin: 0 auto;
  }

  > a {
    margin-top: 20px;
  }

  .Select-placeholder {
    padding: 10px;
  }

  .Select-arrow-zone {
    position: absolute;
    top: 26%;
    right: 10px;
    transform: rotate(-90deg) translateY(-50%);
  }

  ${media.tablet`
    .captcha > div > div > div {
      margin: 0;
    }

    .Select-control {
      padding: 10px;
      height: 38px;
      font-size: 1.3rem;
    }

    .Select--single>.Select-control .Select-value {
      top: 3px;
    }

    .Select-placeholder {
      font-size: 1.5rem;
      padding: 5px 9px;
    }
  `};
`;

export const Label = styled.label`
  display: block;
  font-size: 1.6rem;
  margin-bottom: 20px;
  text-transform: uppercase;

  ${media.tablet`
    font-size: 1.6rem;
  `};
`;

export const Input = styled.input`
  width: 100%;
  outline: none;
  font-size: 1.5rem;
  display: block;
  border: 1px solid #ccc;
  border-radius: 30px;
  margin-bottom: 30px;
  padding: 15px;
  height: 50px;

  ${media.tablet`
    padding: 10px;
    height: 38px;
    font-size: 1.3rem;
  `};
`;

export const TextArea = styled.textarea`
  width: 100%;
  outline: none;
  display: block;
  border: 1px solid ${props => props.theme.color.lightGrey};
  border-radius: 10px;
  margin-bottom: 20px;
  resize: none;
  padding: 15px;
  height: 180px;

  ${media.tablet`
    font-size: 1.3rem;
    height: 174px;
    padding: 10px;
  `};
`;

export const Message = styled.p`
  font-size: 1.6rem;
  color: ${props =>
    props.type === 'error'
      ? props.theme.color.primary
      : props.theme.color.secondary};
  margin-bottom: 2rem;
  text-align: center;

  ${media.tablet`
    font-size: 2rem;
  `};
`;
